import {h, Fragment} from "preact"
import { SerpElement, useCurrencyFormatting } from "@nosto/preact"
import { productImagePlaceholder } from "../helpers"

export default function Product({ product, gridOption, showOnModel }) {

    const settings = window.plpSettings || {};

    const { format } = useCurrencyFormatting()

    const rating = product.customFields?.find(obj => obj.key === 'okendo-reviewswidgetsnippet');

    let subheading = '';

    const productCardSubheading = product.customFields?.find(obj => obj.key === 'product_card_subheading')?.value || '';
    const materials = product.customFields?.find(obj => obj.key === 'custom-materials')?.value 
        ? JSON.parse(product.customFields.find(obj => obj.key === 'custom-materials').value) 
        : [];
    
    if (productCardSubheading) {
        subheading = productCardSubheading;
    } else if (materials.length > 0) {
        subheading = materials.join(' · ');
    }
    

    let primaryImage = product.imageUrl ?? productImagePlaceholder
    let hoverImage = product.alternateImageUrls?.[1] ? product.alternateImageUrls?.[1] : product.alternateImageUrls?.[0]

    if(showOnModel) {
        primaryImage = product.alternateImageUrls?.[1] ? product.alternateImageUrls?.[1] : product.alternateImageUrls?.[0]
        if(!primaryImage) {
            primaryImage = product.imageUrl ?? productImagePlaceholder
        }
        hoverImage = product.imageUrl
    }

    // Badge logic
    let badgeContent = null;

    // Find metafields
    const enablePresale = product.customFields?.find(obj => obj.key === 'enable_presale')?.value === 'true';
    const presaleMessage = product.customFields?.find(obj => obj.key === 'presale_message')?.value;
    const customBadge = product.customFields?.find(obj => obj.key === 'custom_badge')?.value;

    // Presale badge
    if (enablePresale && presaleMessage) {
        badgeContent = <span className="card__custom-badge">{presaleMessage}</span>;
    }
    // Custom badge
    else if (customBadge) {
        badgeContent = <span className="card__custom-badge">{customBadge}</span>;
    }
    // Low stock badge
    else {
        let isLowStock = false;
        const minInventory = settings.low_stock_threshold + 1;

        if (settings.use_total_inventory) {
            let totalInventory = 0;
            for (const variant of product.skus || []) {
                if (variant.inventoryLevel) {
                    totalInventory += variant.inventoryLevel || 0;
                }
            }
            if (totalInventory < settings.low_stock_threshold && totalInventory > 0) {
                isLowStock = true;
            }
        } else {
            let minVariantInventory = minInventory;
            for (const variant of product.skus || []) {
                if (variant.inventoryLevel < minVariantInventory && variant.inventoryLevel > 0) {
                    minVariantInventory = variant.inventoryLevel;
                }
            }
            if (minVariantInventory < settings.low_stock_threshold && minVariantInventory > 0) {
                isLowStock = true;
            }
        }

        if (isLowStock) {
            badgeContent = <span className="card__custom-badge">Limited units</span>;
        }
    }

    const formatPrice = price => {
        const formatted = Math.ceil(price * Shopify.currency.rate).toFixed(0);
        let result = formatted;
        // if (settings.show_currency_icon && settings.currency_symbol) {
        //     result = `${settings.currency_symbol}${result}`;
        // }
        // if (settings.show_currency_code && settings.currency_code) {
        //     result = `${result} ${settings.currency_code}`;
        // }
        return result;
    };

    return (
        <SerpElement
            as="div"
            hit={product}
            class="nosto-product">
            <div className={`nosto-product__media color-scheme-1 ${settings.show_secondary_image && hoverImage ? 'show-secondary' : ''}`} data-quick-add-image-wrapper>
                <img
                    class="nosto-product__primary-img"
                    src={primaryImage}
                    alt={product.name}
                    width="600"
                    height="400"
                />
                {settings.show_secondary_image && hoverImage &&
                <img
                    class="nosto-product__secondary-img"
                    src={hoverImage}
                    alt={product.name}
                    width="600"
                    height="400"
                    />
                }
                <a href={product.url} class="full-unstyled-link" className="nosto-product__action">
                    <button
                        data-with-epi="true"
                        id="swym-collections"
                        className={`button button--wishlist-card swym-button product_${product.productId} swym-icontext swym-heart swym-loaded`}
                        data-swym-add-to-wishlist-view-product={true}
                        data-swym-button={true}
                        data-swaction="addToWishlist"
                        data-product-id={product.productId}
                        data-variant-id={product.skus?.[0]?.id || ''}
                        data-product-url={product.url}
                        aria-label="Add To Wishlist"
                        >                    
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="23" viewBox="0 0 18 23" fill="none" aria-hidden="true" focusable="false" class="icon icon-bookmark">
                            <path d="M8.83967 18.5701L1.56033 21.7549C1.29605 21.8705 1 21.6769 1 21.3884V1.4C1 1.17909 1.17909 1 1.4 1H9H16.6C16.8209 1 17 1.17909 17 1.4V21.3884C17 21.6769 16.7039 21.8705 16.4397 21.7549L9.16033 18.5701C9.05812 18.5254 8.94188 18.5254 8.83967 18.5701Z" stroke="currentColor"></path>
                        </svg>
                    </button>
                    <div className="nosto-product__main-badge">
                        <div className={`card__badge ${settings.badge_position}`}>
                        {(() => {
                            // Check if product handle contains 'beautiful-dark-x-atreyu'
                            const show_badge = !product.url.includes('beautiful-dark-x-atreyu');

                            // Sold out badge
                            if (product.availability !== 'InStock') {
                            return (
                                <span
                                id={`NoMediaStandardBadge-${product.productId}`}
                                className="badge badge--bottom-left card__badge--sold-out"
                                >
                                Sold Out
                                </span>
                            );
                            }
                            // Sitewide discount badge
                            else if (settings.sitewide_discount_enabled && product.customFields?.find(obj => obj.key === 'gift_card')?.value !== 'true' && show_badge) {
                            let total_discount_percentage = settings.sitewide_discount_pricing_percentage;
                            let total_discount_decimal = total_discount_percentage * 0.01;
                            let total_discount_complement = 1 - total_discount_decimal;
                            let total_discount_amount = product.price * total_discount_decimal;
                            let new_product_price = product.price * total_discount_complement;

                            // Adjust for already discounted products
                            if (product.listPrice > product.price && product.listPrice != null) {
                                total_discount_amount = product.listPrice - new_product_price;
                                total_discount_decimal = total_discount_amount / product.listPrice;
                                total_discount_percentage = total_discount_decimal * 100;
                            }

                            return (
                                <>
                                {settings.show_sitewide_discount_as_percentage && (
                                    <span className="badge badge--bottom-left card__badge--sale on-sale-badge--discount-as-percentage">
                                    {Math.floor(total_discount_percentage)}% Off
                                    </span>
                                )}
                                {settings.show_sitewide_discount_as_amount && (
                                    <span className="badge badge--bottom-left card__badge--sale on-sale-badge--discount-as-amount">
                                    Save {settings.currency_symbol}{Math.floor(total_discount_amount / 100)}
                                    </span>
                                )}
                                </>
                            );
                            }
                            // Metafield discount badge
                            else if (settings.metafield_discount_enabled && product.customFields?.find(obj => obj.key === 'discount_percentage')?.value && show_badge) {
                            let total_discount_percentage = parseFloat(product.customFields.find(obj => obj.key === 'discount_percentage').value);
                            let total_discount_decimal = total_discount_percentage * 0.01;
                            let total_discount_complement = 1 - total_discount_decimal;
                            let total_discount_amount = product.price * total_discount_decimal;
                            let new_product_price = product.price * total_discount_complement;

                            // Adjust for already discounted products
                            if (product.listPrice > product.price && product.listPrice != null) {
                                total_discount_amount = product.listPrice - new_product_price;
                                total_discount_decimal = total_discount_amount / product.listPrice;
                                total_discount_percentage = total_discount_decimal * 100;
                            }

                            return (
                                <>
                                {settings.show_metafield_discount_as_percentage && (
                                    <span className="badge badge--bottom-left card__badge--sale on-sale-badge--discount-as-percentage">
                                    {Math.floor(total_discount_percentage)}% Off
                                    </span>
                                )}
                                {settings.show_metafield_discount_as_amount && (
                                    <span className="badge badge--bottom-left card__badge--sale on-sale-badge--discount-as-amount">
                                    Save {settings.currency_symbol}{Math.floor(total_discount_amount / 100)}
                                    </span>
                                )}
                                </>
                            );
                            }
                            // Manual badge
                            else if (product.customFields?.find(obj => obj.key === 'manual_product_card_badge')?.value) {
                            const manual_badge = JSON.parse(product.customFields.find(obj => obj.key === 'manual_product_card_badge').value);
                            const manual_badge_name = manual_badge.name?.toLowerCase().replace(/\s+/g, '-');

                            return (
                                <>
                                <style>
                                    {`.badge--1-${manual_badge_name} {
                                    background-color: ${manual_badge.badge_1_background_colour};
                                    color: ${manual_badge.badge_1_text_colour};
                                    }
                                    .badge--2-${manual_badge_name} {
                                    background-color: ${manual_badge.badge_2_background_colour};
                                    color: ${manual_badge.badge_2_text_colour};
                                    }`}
                                </style>
                                {manual_badge.badge_1_text && (
                                    <span className={`badge badge--manual-1 badge--1-${manual_badge_name}`}>
                                    {manual_badge.badge_1_text}
                                    </span>
                                )}
                                {manual_badge.badge_2_text && (
                                    <span className={`badge badge--manual-2 badge--2-${manual_badge_name}`}>
                                    {manual_badge.badge_2_text}
                                    </span>
                                )}
                                </>
                            );
                            }
                            // Final sale badge
                            else if (product.tags1?.includes('Final Sale') && settings.final_sale_badge_on_product_card_enabled) {
                            return (
                                <span className="badge badge--bottom-left card__badge--sale">
                                Final Sale
                                </span>
                            );
                            }
                            // Sale badge (using custom-sale_item metafield)
                            else if (product.customFields?.find(obj => obj.key === 'custom-sale_item')?.value === 'true') {
                            return (
                                <span
                                id={`NoMediaStandardBadge-${product.productId}`}
                                className="badge badge--bottom-left card__badge--sale"
                                >
                                Sale
                                </span>
                            );
                            }
                            // Early access badge
                            else if (product.customFields?.find(obj => obj.key === 'early_access')?.value === 'true') {
                            return (
                                <span className="badge badge--bottom-left card__badge--new">
                                Early access
                                </span>
                            );
                            }
                            // New badge (using custom-new_arrivals metafield)
                            else if (product.customFields?.find(obj => obj.key === 'custom-new_arrivals')?.value === 'true') {
                            return (
                                <span className="badge badge--bottom-left card__badge--new">
                                New
                                </span>
                            );
                            }
                            // Bestseller badge
                            else if (product.tags1?.includes('Bestseller')) {
                            return (
                                <span className="badge badge--bottom-left card__badge--bestseller">
                                Bestseller
                                </span>
                            );
                            }
                            // Collaboration badge
                            else if (product.tags1?.includes('Collaboration')) {
                            return (
                                <span className="badge badge--bottom-left card__badge--collaboration">
                                Collaboration
                                </span>
                            );
                            }

                            return null;
                        })()}
                        </div>
                    </div>
                    <div className="nosto-product__quick-add quick-add-component" data-product-id={product.productId}>
                        {product.skus?.length == 1 && 
                        <form
                        id={`${product.productId}-form`}
                        className="form quick-add-form"
                        noValidate="novalidate"
                        data-type="add-to-cart-form">
                            <input
                                type="hidden"
                                name="id"
                                value={product.skus?.[0].id}
                                className="product-variant-id"
                                disabled={product.skus?.[0].availability !== "InStock"}
                            />
                            <button
                                id={`${product.productId}-form-submit`}
                                type="submit"
                                name="add"
                                className="quick-add__trigger quick-add__trigger--single"
                                aria-label={`Add ${product.name} to cart`}
                                disabled={product.skus?.[0]?.availability !== "InStock"}
                            >
                                <span className="icon-wrap">
                                    <svg 
                                    xmlns="http://www.w3.org/2000/svg"
                                    aria-hidden="true"
                                    focusable="false"
                                    class="icon icon-plus"
                                    fill="none" 
                                    viewBox="0 0 16 17"
                                    >
                                    <path d="M7.50039 16.1617V8.81172H0.150391V8.11172H7.50039V0.761719H8.20039V8.11172H15.5504V8.81172H8.20039V16.1617H7.50039Z" fill="currentColor"/>
                                    </svg>
                                </span>
                            </button>
                        </form>}
                        {product.skus?.length > 1 && 
                        <>
                            <button
                                type="button"
                                class="quick-add__trigger quick-add__trigger--variants"
                                data-product-id={product.productId}
                                data-product-handle={product.url.split('/products/')[1]}
                                aria-label={`Quick add ${product.name}`}
                            >
                                <span className="icon-wrap">
                                    <svg 
                                        xmlns="http://www.w3.org/2000/svg"
                                        aria-hidden="true"
                                        focusable="false"
                                        class="icon icon-plus"
                                        fill="none" 
                                        viewBox="0 0 16 17"
                                        >
                                        <path d="M7.50039 16.1617V8.81172H0.150391V8.11172H7.50039V0.761719H8.20039V8.11172H15.5504V8.81172H8.20039V16.1617H7.50039Z" fill="currentColor"/>
                                    </svg>
                                </span>
                            </button>
                            <div
                                className="quick-add-overlay no-js-hidden"
                                id={`quick-add-overlay-${product.productId}`}
                                style={{ display: 'none' }}
                            >
                                <div className="quick-add-drawer">
                                    <div className="quick-add-drawer__content">
                                        <h3 className="quick-add-drawer__title">SELECT SIZE</h3>
                                        <div className="quick-add-drawer__variants">
                                            {product.skus?.map(sku => (
                                                <button
                                                    key={sku.id}
                                                    type="button"
                                                    className={`quick-add-variant-btn${sku.availability !== "InStock" ? ' variant-unavailable' : ''}`}
                                                    data-variant-id={sku.id}
                                                    data-variant-available={sku.availability === "InStock"}
                                                    disabled={sku.availability !== "InStock"}
                                                >
                                                    {sku.name}
                                                    {sku.availability !== "InStock" && 
                                                        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <mask id="mask0_2376_20462" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="17" height="16">
                                                            <rect x="0.5" width="16" height="16" fill="currentColor"/>
                                                            </mask>
                                                            <g mask="url(#mask0_2376_20462)">
                                                            <path d="M3.5 12.5897V11.5898H4.70517V6.61533C4.70517 5.71878 4.98189 4.92605 5.53533 4.23716C6.08867 3.54828 6.79911 3.10766 7.66667 2.91533V2.5C7.66667 2.26855 7.74761 2.07178 7.9095 1.90966C8.07139 1.74766 8.26794 1.66666 8.49917 1.66666C8.7305 1.66666 8.92733 1.74766 9.08967 1.90966C9.25211 2.07178 9.33333 2.26855 9.33333 2.5V2.91533C10.2009 3.10766 10.9113 3.54828 11.4647 4.23716C12.0181 4.92605 12.2948 5.71878 12.2948 6.61533V11.5898H13.5V12.5897H3.5ZM8.49883 14.4615C8.16717 14.4615 7.88361 14.3435 7.64817 14.1075C7.41261 13.8715 7.29483 13.5878 7.29483 13.2563H9.70517C9.70517 13.5889 9.58706 13.8729 9.35083 14.1083C9.11461 14.3438 8.83061 14.4615 8.49883 14.4615ZM5.70517 11.5898H11.2948V6.61533C11.2948 5.84355 11.022 5.18483 10.4763 4.63916C9.93056 4.09339 9.27178 3.8205 8.5 3.8205C7.72822 3.8205 7.06944 4.09339 6.52367 4.63916C5.978 5.18483 5.70517 5.84355 5.70517 6.61533V11.5898Z" fill="currentColor"/>
                                                            </g>
                                                        </svg>
                                                    }
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                        }
                    </div>
                </a>
            </div>
            <div className="nosto-product__info">
                <div className="nosto-product__title-wrap">
                    <h3 className="card__heading h5"><a href={product.url} class="full-unstyled-link">{product.name}</a></h3>
                    {rating?.value && <span class="nosto-product__rating">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <mask id="mask0_3_2481" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="12" height="12">
                                <rect width="12" height="12" rx="0.3" fill="#D9D9D9"/>
                            </mask>
                            <g mask="url(#mask0_3_2481)">
                                <path d="M3.5195 10.1338C3.29254 10.2707 3.01252 10.0676 3.07226 9.80934L3.6843 7.16347C3.70934 7.05521 3.67249 6.94198 3.58853 6.86919L1.53549 5.08926C1.33523 4.91564 1.44202 4.58663 1.70607 4.56371L4.41996 4.32813C4.53072 4.31851 4.62707 4.24844 4.67035 4.14604L5.72367 1.65382C5.82691 1.40954 6.17309 1.40954 6.27633 1.65382L7.32965 4.14604C7.37293 4.24844 7.46928 4.31851 7.58004 4.32813L10.2939 4.56371C10.558 4.58663 10.6648 4.91564 10.4645 5.08926L8.41147 6.86919C8.32751 6.94198 8.29066 7.05521 8.3157 7.16347L8.92774 9.80934C8.98748 10.0676 8.70747 10.2707 8.4805 10.1338L6.15496 8.73098C6.05965 8.67348 5.94035 8.67348 5.84504 8.73098L3.5195 10.1338Z" fill="#989898"/>
                            </g>
                        </svg>
                        {rating?.value.split(' ')[0]}
                        </span>}
                </div>
                {subheading && <div class="nosto-product__subheading">{subheading}</div>}
                <div className="nosto-product__price-wrap">
                    <div class="nosto-product__price-price">
                        {product.listPrice && product.listPrice > product.price && (
                            <span class="nosto-product__compare-price">
                                {settings.currency_symbol}{formatPrice(product.listPrice)} {settings.currency_code}
                            </span>
                        )}
                        <span class="nosto-product__price">{settings.currency_symbol}{formatPrice(product.price)} {settings.currency_code}</span>
                    </div>
                    <div className="nosto-product__badge">
                        {badgeContent}
                    </div>
                </div>
            </div>
        </SerpElement>
    )
}